export const GET_UP_COMING_BOOKINGS_API = "/bookings/upcoming";
export const GET_PAST_BOOKINGS_API = "/bookings/past";
export const GET_BOOKINGS_DETAILS_API = "/bookings/detail/";
export const GET_INVITE_DETAILS_API = "/openbooking/getguestdetails/";
export const GET_PATRON_INVITES_DATE_API = "/bookings/openinvitesdate";
export const GET_PATRON_INVITES_API = "/bookings/getopeninvites";
